module.exports = __webpack_public_path__ + "img/arrow-right-solid.bd021148.svg";